@import "../../shared.css";

:host {
	display: flex;
	position: relative;
	max-width: 100vw;
	background-color: rgb(var(--smoothly-input-background));
	box-sizing: border-box;
	min-height: var(--input-min-height);
}

:host>smoothly-input {
	--input-min-height: calc(var(--input-min-height) - 2px);
	--smoothly-input-border-focus: none;
}

:host:not([readonly])>smoothly-input>div>input {
	cursor: pointer;
}

:host[disabled],
:host[disabled]>smoothly-input>div>input {
	cursor: not-allowed;
}

:host[looks=transparent] smoothly-input {
	outline: none;
}

:host>smoothly-calendar {
	position: absolute;
	z-index: 20;
	top: 4rem;
	background-color: rgb(var(--smoothly-input-background));
	min-width: 18rem;
	max-width: 22rem;
}

:host>smoothly-calendar::before {
	content: "";
	box-sizing: border-box;
	position: absolute;
	top: -0.55rem;
	left: 2rem;
	z-index: 9;
	transform: rotate(45deg);
	width: 1rem;
	height: 1rem;
	background-color: rgb(var(--smoothly-input-background));
	border-top: 1px solid rgb(var(--smoothly-input-border));
	border-left: 1px solid rgb(var(--smoothly-input-border));
}

:host>span.icons {
	display: flex;
	flex-direction: row;
	align-items: center;
}
:host>smoothly-input[name="date"] {
	width: 12rem;
}
:host>smoothly-input[name="hour"] {
	width: 4rem;
}
:host>smoothly-input[name="minute"] {
	min-width: 4rem;
	flex-grow: 1;
}
:host>span.colon {
	padding: 
		var(--input-value-padding-top) 
		var(--input-padding-side) 
		var(--input-value-padding-bottom) 
		var(--input-padding-side);
}
:host>.icons>.smoothly-invalid {
	display: none;
	z-index: 2;
	cursor: pointer;
	padding: 0.5rem;
}
:host[invalid]>.icons>.smoothly-invalid {
	display: flex;
}
